import eventManager from 'common/services/-RFC.eventManager';

angular.module('controllers')
    .controller(
        'SessionExpire',
        (
            $scope, $rootScope, $document, $location, $window,
            $modal, $modalInstance, modalParams,
        ) => {

        // modalParams is a parameter injected from $modal.open() -> SessionManagement model
            $scope.modalParams = modalParams;

            // append class to body when session expire modal appears
            angular.element($document[0].body).addClass('expire-modal');

            // Close modal if the user's internet connection is back online
            eventManager.subscribe('connection:online', () => {

                if ($scope.modalParams === 'offline') {

                    angular.element($document[0].body).removeClass('expire-modal');
                    $modalInstance.close();

                }

            });

            $scope.refreshPage = () => {

                $window.location.href = $location.path();

            };

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/session-expire.js